/**
 * @file logout.saga.js
 * @description
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Apr 10, 2026 21:44
 */
import { call, put, takeLatest } from 'redux-saga/effects';
import axiosClient from 'src/services/axiosClient.js';

import standardMessages from 'src/services/notifications/standardMessages';

import { objectHas, stringExists } from 'src/@common/utilities';

import {
    enqueueMessage,
} from 'src/store/actions/global.actions';

import {
    AUTH_LOGOUT_REQUEST,
    logoutSuccess,
    logoutFailure,
} from 'src/store/actions/auth.actions';

import { dataLoadingSet } from 'src/store/actions/global.actions';

function callApi() {
    const url = '/auth/logout';

    const baseUrl = import.meta.env.VITE_APP_API_BASE_URL;

    const config = {
        method: 'post',
        baseURL: baseUrl,
        url,
        data: {
        }
    };

    return new Promise((resolve, reject) => {
        axiosClient(config)
            .then((response) => {
                resolve(response.data);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

function* requestSaga(action) {
    try {
        yield put(dataLoadingSet(true));

        const resp = yield call(callApi, action.payload);

        yield put(dataLoadingSet(false));
        yield put(logoutSuccess(resp.payload));

        if (stringExists(resp.payload.serverMessage)) {
            yield put(enqueueMessage(
                resp.payload.serverMessage,
                standardMessages.generalInfoMessage.options)
            );
        }

    } catch (error) {
        yield put(dataLoadingSet(false));
        yield put(logoutFailure(error));

        if (objectHas(error, 'response.data.payload.serverMessage')) {
            if (stringExists(error.response.data.payload.serverMessage)) {
                yield put(enqueueMessage(
                    error.response.data.payload.serverMessage,
                    standardMessages.serverError.options)
                );
            }
        }

    }
}

export default function* requestMonitor() {
    yield takeLatest(AUTH_LOGOUT_REQUEST, requestSaga);
}
